/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum ParticipantOrganisationType {
  PublicSector = 'PublicSector',
  CivilSociety = 'CivilSociety',
  Producers = 'Producers',
  PrivateSector = 'PrivateSector',
  Donors = 'Donors',
  FinancialServices = 'FinancialServices',
}
